import { useLocation } from "react-router-dom";

const siteUrl = "https://www.timscdrmumbai.in";

const routeMetadata = {
  "/": {
    title: "Best MCA College in Mumbai | TIMSCDR Kandivali",
    description: "Thakur Institute of Management Studies, Career Development & Research (TIMSCDR) is a leading MCA college in Mumbai with industry-focused Computer Applications education.",
  },
  "/about/Vision-Mission": {
    title: "Vision & Mission | Leading MCA College in India - TIMSCDR",
    description: "Explore the vision and mission of TIMSCDR, a top MCA college in Mumbai, focused on software education, emerging technologies, leadership, research and professional development.",
  },
  "/peo-Page": {
    title: "MCA Program Educational Objectives (PEOs) | TIMSCDR Mumbai",
    description: "Discover the MCA PEOs and POs at TIMSCDR, Mumbai, focused on software development, emerging technologies, research, leadership and professional development.",
  },
  "/about/Education-Policies": {
    title: "Organization Policy | Trusted MCA College in Mumbai - TIMSCDR",
    description: "Explore the education policies at TIMSCDR, a top MCA college in Mumbai, supporting quality education, academic excellence, student development and professional learning.",
  },
  "/about/chairman-message": {
    title: "Chairman's Message | TIMSCDR - MCA College in Mumbai",
    description: "Read the Chairman's Message at TIMSCDR, one of the leading MCA colleges in Mumbai, committed to academic excellence, innovation, quality education, and student success.",
  },
  "/about/ceo-message": {
    title: "CEO's Message | Top MCA College in Mumbai - TIMSCDR",
    description: "Read the CEO's message from Thakur Institute of Management Studies, Career Development & Research and learn about our vision for quality education and innovation.",
  },
  "/about/director-message": {
    title: "Director Message | MCA College in Mumbai - Timscdr",
    description: "Read the Director's Message from Thakur Institute of Management Studies, Career Development & Research, sharing our vision for academic excellence and innovation.",
  },
  "/about/governing-council": {
    title: "Governing Council | Top MCA College in Mumbai - TIMSCDR",
    description: "Meet the Governing Council at TIMSCDR, a top MCA college in Mumbai, guiding academic excellence, institutional governance, quality education, and strategic growth.",
  },
  "/about/advisory": {
    title: "Advisory Board | Best MCA College in Mumbai | TIMSCDR",
    description: "Meet the Advisory Board at TIMSCDR, a top MCA college in Mumbai, fostering innovation, industry collaboration, academic excellence, and student success.",
  },
  "/about/academic-council": {
    title: "Academic Council | Top MCA College in Mumbai - TIMSCDR",
    description: "Meet the Academic Council at TIMSCDR, a top MCA college in Mumbai, guiding academic excellence, curriculum development, quality education, and institutional growth.",
  },
  "/about/development-committee": {
    title: "College Development Committee | TIMSCDR Mumbai",
    description: "Explore the College Development Committee at TIMSCDR, dedicated to institutional growth, academic excellence, quality education, and strategic development.",
  },
  "/about/cells-and-committees": {
    title: "Cells & Committees | TIMSCDR Kandivali, Mumbai",
    description: "Explore the Cells & Committees at TIMSCDR Kandivali, fostering student welfare, academic quality, research, inclusivity, ethical practices, and institutional development.",
  },
  "/organogram": {
    title: "Institute Organogram | TIMSCDR Kandivali, Mumbai",
    description: "Explore the Organogram of Thakur Institute of Management Studies, Career Development & Research, outlining its organizational structure and governance.",
  },
  "/policies": {
    title: "Academic & Administrative Policies | TIMSCDR Mumbai",
    description: "Explore the policies of Thakur Institute of Management Studies, Career Development & Research, covering academic, administrative, and institutional guidelines.",
  },
  "/programs/mca-program": {
    title: "Master of Computer Applications (MCA) | TIMSCDR Kandivali, Mumbai",
    description: "Join TIMSCDR Kandivali, a leading MCA college in Mumbai, and pursue a Master of Computer Applications with industry-focused learning and excellent placement support.",
  },
  "/programs/mca-working-professionals": {
    title: "MCA for Working Professionals | TIMSCDR Kandivali, Mumbai",
    description: "Explore the Top MCA Program for Working Professionals in Mumbai at Thakur Institute of Management Studies, Career Development & Research with flexible hybrid learning.",
  },
  "/programs/integrated-mca": {
    title: "Integrated MCA | TIMSCDR Kandivali, Mumbai",
    description: "Join the 5-Year Integrated MCA programme at TIMSCDR Kandivali, one of the leading Integrated MCA colleges in Mumbai, and build a successful IT career.",
  },
  "/programs/ph-d-admission": {
    title: "Ph.D. in Computer Application Admissions | TIMSCDR Mumbai",
    description: "Join TIMSCDR, one of the best colleges in Mumbai, for a Ph.D. in Computer Application with expert faculty, research opportunities, and academic excellence.",
  },
  "/admissions/mca-program": {
    title: "MCA Admission | Best MCA College in Mumbai | TIMSCDR",
    description: "Apply to one of the Top MCA Colleges in Mumbai at Thakur Institute of Management Studies, Career Development & Research and build a successful IT career.",
  },
  "/admissions/mca-working-professionals": {
    title: "MCA Admission for Working Professionals | TIMSCDR",
    description: "Apply for MCA Admission for Working Professionals at Thakur Institute of Management Studies, Career Development & Research with flexible hybrid learning.",
  },
  "/admissions/imca": {
    title: "MCA Integrated Admissions in Mumbai | Apply at TIMSCDR",
    description: "Apply for Integrated MCA Admission at Thakur Institute of Management Studies, Career Development & Research and build a strong foundation for a successful IT career.",
  },
  "/programs/ph-d-admissionn": {
    title: "Ph.D. in Computer Applications | TIMSCDR mumbai",
    description: "Apply for the Ph.D. Program at Thakur Institute of Management Studies, Career Development & Research and pursue advanced research in Computer Applications.",
  },
  "/seat-distribution": {
    title: "Seat Distribution | MCA Admissions | TIMSCDR Mumbai",
    description: "Explore the seat distribution at Thakur Institute of Management Studies, Career Development & Research for MCA, Integrated MCA and MCA for Working Professionals.",
  },
  "/aicte-approval-2": {
    title: "AICTE Approved Institute | Thakur TIMSCDR Mumbai",
    description: "View the AICTE Approval documents of Thakur Institute of Management Studies, Career Development & Research for approved MCA programs and academic years.",
  },
  "/admission-notification": {
    title: "Latest MCA Admission Notifications | TIMSCDR Mumbai",
    description: "View the latest admission notifications from Thakur Institute of Management Studies, Career Development & Research for MCA, Integrated MCA and Ph.D. programs.",
  },
  "/student-handbook": {
    title: "Student Handbook | TIMSCDR Mumbai MCA Institute",
    description: "Access the TIMSCDR Student Handbook for academic regulations, code of conduct, student support services, placements, campus policies, and MCA guidelines.",
  },
  "/code-of-conduct": {
    title: "Student Code of Conduct at TIMSCDR Mumbai | MCA",
    description: "Read the TIMSCDR Student Code of Conduct covering academic integrity, attendance, discipline, ethics, campus rules, and student responsibilities for MCA programmes.",
  },
  "/student-mentoring-program": {
    title: "Student Mentoring Program | TIMSCDR Mumbai MCA Institute",
    description: "Discover the TIMSCDR Student Mentoring Program, offering academic guidance, personal support, skill development, and career mentoring to help MCA students succeed.",
  },
  "/anti-ragging": {
    title: "Anti-Ragging Policy | TIMSCDR Mumbai MCA Institute",
    description: "Learn about the TIMSCDR Anti-Ragging Policy, ensuring a safe, respectful, and inclusive campus with strict anti-ragging measures, awareness, and student support.",
  },
  "/canditate-aganist-cap": {
    title: "Candidate Against CAP | TIMSCDR Kandivali, Mumbai",
    description: "Apply for Candidate Against CAP admission at TIMSCDR Mumbai. Explore eligibility, admission process, required documents, seat availability, and MCA admission guidelines.",
  },
  "/fra-fee-structure": {
    title: "FRA Fee Structure | MCA Institute in Mumbai | TIMSCDR",
    description: "View the TIMSCDR FRA-approved MCA fee structure, including tuition fees, development fees, management seat fees, refundable deposits, and admission details.",
  },
  "/integrated-mca-2": {
    title: "Integrated MCA Program | TIMSCDR Mumbai Admissions",
    description: "Explore the Integrated MCA Program at TIMSCDR Mumbai with industry-focused curriculum, expert faculty, practical learning, and excellent career opportunities.",
  },
  "/phd": {
    title: "Ph.D. in Computer Applications in Mumbai | TIMSCDR",
    description: "Explore Ph.D. admission in Computer Applications at TIMSCDR, Mumbai. Discover eligibility, research areas and opportunities for advanced academic research.",
  },
  "/faculty-list-2": {
    title: "Faculty List | Best MCA Institute TIMSCDR Mumbai",
    description: "Explore the TIMSCDR faculty list featuring experienced professors, associate professors, and assistant professors dedicated to quality MCA education and research.",
  },
  "/staff": {
    title: "Faculty at TIMSCDR Mumbai | Experienced MCA Faculty",
    description: "Explore the faculty at TIMSCDR, one of the leading MCA colleges in Mumbai. Meet experienced professors and faculty members in computer applications and technology.",
  },
  "/non-teaching-staff": {
    title: "Non Teaching Staff | Top MCA Colleges in Mumbai | TIMSCDR",
    description: "Meet the non-teaching staff at TIMSCDR Mumbai, providing administrative, technical, and student support services to ensure smooth academic and campus operations.",
  },
  "/teaching-pedagogy": {
    title: "Teaching Pedagogy | Best MCA College in Mumbai | TIMSCDR",
    description: "Explore the teaching pedagogy at TIMSCDR Mumbai, combining innovative learning methods, industry-focused curriculum, practical exposure, and academic excellence.",
  },
  "/student-downloads": {
    title: "Student Downloads | TIMSCDR Mumbai MCA Institute",
    description: "Download important student forms, academic documents, certificates, policies, notices, and essential resources from the TIMSCDR Student Downloads portal.",
  },
  "/facilities/infrastructure": {
    title: "Infrastructure | Best MCA College in Mumbai | TIMSCDR",
    description: "Explore TIMSCDR Mumbai's modern infrastructure featuring smart classrooms, advanced computer labs, digital library, seminar halls, hostel, and student facilities.",
  },
  "/facilities/disability-resource-center": {
    title: "Disability Resource Center | TIMSCDR Mumbai Institute",
    description: "Explore the Disability Resource Center at TIMSCDR Mumbai, offering accessible facilities, academic support, inclusive services, and equal opportunities for students.",
  },
  "/about-library": {
    title: "About Library | Top MCA College | TIMSCDR Mumbai",
    description: "Explore the library at TIMSCDR, a top MCA college in Mumbai, offering books, e-books, journals, digital resources, reading facilities, and research support.",
  },
  "/infrastructure-and-facilities": {
    title: "Infrastructure & Facilities | Best MCA College | TIMSCDR Mumbai",
    description: "Explore modern infrastructure and facilities at TIMSCDR, a top MCA college in Mumbai, with smart classrooms, advanced labs, library, Wi-Fi, and student amenities.",
  },
  "/timscdr-library-holding": {
    title: "Library Holdings | Top MCA College in Mumbai | TIMSCDR",
    description: "Explore TIMSCDR Library Holdings at a top MCA college in Mumbai, featuring books, journals, e-books, research resources, and year-wise library collection details.",
  },
  "/library-timing-and-rules": {
    title: "Library Timings & Rules | Best MCA College in mumbai | TIMSCDR",
    description: "Check the library timings and rules at TIMSCDR, a top MCA college in Mumbai. Learn about library hours, borrowing policies, student guidelines, and library services.",
  },
  "/virtual-reading-resources": {
    title: "Virtual Reading Resources | MCA College in Kandivali | TIMSCDR",
    description: "Access virtual reading resources at TIMSCDR, a top MCA college in Mumbai, including e-books, e-journals, digital libraries, research databases, and online learning tools.",
  },
  "/research-cell": {
    title: "Research Cell | Top MCA College in Mumbai | TIMSCDR",
    description: "Explore the Research Cell at TIMSCDR, a top MCA college in Mumbai, promoting innovation, funded projects, publications, industry collaboration, and research excellence.",
  },
  "/institution-innovation-council-iic": {
    title: "Institution Innovation Council | MCA College | TIMSCDR Mumbai",
    description: "Explore the Institution Innovation Council (IIC) at TIMSCDR, a top MCA college in Mumbai, promoting innovation, entrepreneurship, startups, research, and creative learning.",
  },
  "/icaim-2026": {
    title: "ICAIM 2026 | Best MCA College in Mumbai | TIMSCDR",
    description: "TIMSCDR (Thakur Institute of Management Studies, Career Development & Research) is a top MCA college in Mumbai offering quality education, research, and innovation.",
  },
  "/icaim-2025": {
    title: "ICAIM 2025 | Top MCA College in Mumbai | TIMSCDR",
    description: "Explore ICAIM 2025 at TIMSCDR, a top MCA college in Mumbai, featuring AI research, expert talks, paper presentations, hackathons, workshops, and innovation.",
  },
  "/best-mca-college-in-mumbai-for-placements-about-placement": {
    title: "Best MCA College in Mumbai for Placements | TIMSCDR",
    description: "Explore placement opportunities at TIMSCDR, one of the leading MCA colleges in Mumbai. Discover recruiters, career support, industry exposure and placement highlights.",
  },
  "/training-programme": {
    title: "Training Programme for MCA Students in Mumbai | TIMSCDR",
    description: "Explore training programmes at TIMSCDR, Mumbai, including student development, workshops, aptitude training, resume building, interview preparation and more.",
  },
  "/placement-data": {
    title: "MCA Placement Data & Statistics in Mumbai | TIMSCDR",
    description: "Explore MCA placement data and statistics at TIMSCDR, Mumbai. View placement records, internship outcomes and career opportunities across multiple batches.",
  },
  "/training-placement-policy": {
    title: "Training & Placement Policy | Top MCA College | TIMSCDR",
    description: "Read the Training & Placement Policy at TIMSCDR, a top MCA college in Mumbai, covering eligibility, placement process, student guidelines, and recruitment rules.",
  },
  "/faculty-development-programs": {
    title: "Faculty Development Programs | Top MCA College | TIMSCDR",
    description: "Explore Faculty Development Programs at TIMSCDR, a top MCA college in Mumbai, enhancing teaching excellence, research, innovation, and industry-oriented learning.",
  },
  "/short-term-training-programme": {
    title: "Short Term Training Programme | MCA College in mumbai | TIMSCDR",
    description: "Explore Short Term Training Programmes at TIMSCDR, a top MCA college in Mumbai, enhancing faculty skills through workshops, research, innovation, and industry-focused learning.",
  },
  "/life/trekking": {
    title: "Trekking & Student Activities in Mumbai | TIMSCDR",
    description: "Explore trekking and student activities at TIMSCDR, Mumbai. Discover outdoor experiences, adventure activities and extracurricular opportunities for MCA students.",
  },
  "/life/health-hygiene": {
    title: "Health & Hygiene Activities for Students in Mumbai | TIMSCDR",
    description: "Explore student health and hygiene programmes at TIMSCDR, Mumbai, including blood donation camps, menstrual hygiene awareness, health talks and wellness activities.",
  },
  "/life/clean-india-campaign": {
    title: "Clean India Campaign | Best MCA College | TIMSCDR Mumbai",
    description: "Explore the Clean India Campaign at TIMSCDR, a top MCA college in Mumbai, promoting cleanliness, environmental awareness, social responsibility, and community service.",
  },
  "/life/socialevents": {
    title: "Social Events & Student Activities in Mumbai | TIMSCDR",
    description: "Explore social events at TIMSCDR, a top MCA college in Mumbai, promoting community service, social responsibility, environmental awareness, and student engagement.",
  },
  "/life/hackathon": {
    title: "Hackathons for MCA Students in Mumbai | TIMSCDR",
    description: "Explore hackathons at TIMSCDR, Mumbai, where MCA students develop innovative solutions through coding, AI, problem-solving, teamwork and industry-focused challenges.",
  },
  "/contact": {
    title: "Top MCA College in Mumbai | Contact TIMSCDR Kandivali",
    description: "Contact TIMSCDR Kandivali, a top MCA college in Mumbai, for MCA admissions, programme details, academic enquiries, campus information, address, phone number and email.",
  },
  "/blogs": {
    title: "MCA Blogs & Latest Updates in Mumbai | TIMSCDR",
    description: "Explore TIMSCDR blogs for the latest insights on MCA, computer applications, technology, education, careers, industry trends and student opportunities in Mumbai.",
  },
};

function normalizePath(pathname) {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
}

function RouteSeo() {
  const location = useLocation();
  const path = normalizePath(location.pathname);
  const metadata = routeMetadata[path];

  if (!metadata) return null;

  const canonicalUrl = `${siteUrl}${path === "/" ? "" : path}/`;

  // Directly update document head — works reliably with React 19
  document.title = metadata.title;

  let descTag = document.querySelector('meta[name="description"]');
  if (!descTag) {
    descTag = document.createElement("meta");
    descTag.setAttribute("name", "description");
    document.head.appendChild(descTag);
  }
  descTag.setAttribute("content", metadata.description);

  let canonicalTag = document.querySelector('link[rel="canonical"]');
  if (!canonicalTag) {
    canonicalTag = document.createElement("link");
    canonicalTag.setAttribute("rel", "canonical");
    document.head.appendChild(canonicalTag);
  }
  canonicalTag.setAttribute("href", canonicalUrl);

  let ogTitle = document.querySelector('meta[property="og:title"]');
  if (!ogTitle) {
    ogTitle = document.createElement("meta");
    ogTitle.setAttribute("property", "og:title");
    document.head.appendChild(ogTitle);
  }
  ogTitle.setAttribute("content", metadata.title);

  let ogDesc = document.querySelector('meta[property="og:description"]');
  if (!ogDesc) {
    ogDesc = document.createElement("meta");
    ogDesc.setAttribute("property", "og:description");
    document.head.appendChild(ogDesc);
  }
  ogDesc.setAttribute("content", metadata.description);

  return null;
}

export { routeMetadata };
export default RouteSeo;
